import React from 'react'
import { FormulaireSchemaType } from '../../../lib/formulaireContext/validation/formulaire.schema'
import { Controller, UseFormMethods } from 'react-hook-form'
import { FormTextField } from '../Fields/FormTextField'
import { Link, Grid, Typography, Box, Paper } from '@material-ui/core'
import LaunchRoundedIcon from '@material-ui/icons/LaunchRounded'
import { SectionHelperText } from './SectionHelperText'

type FieldConfig = {
    name: string;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    helperText?: string;
    type?: string;
}

const spotFields: FieldConfig[] = [
    { name: "spot.idCreaCode", label: "Code IDCrea" },
    { name: "spot.brand", label: "Marque", required: true },
    { name: "spot.productName", label: "Nom du produit", required: true },
    { name: "spot.productNature", label: "Nature du produit"},
    { name: "spot.declarant", label: "Annonceur"},
    { name: "spot.spotTitle", label: "Titre du spot", required: true },
    { name: "spot.duration", label: "Durée (en sec.)", required: true, type: "number" },
    { name: "spot.arppCodes", label: "Code ARPP(1)", helperText: "ex : 2018061901" },
    { name: "spot.pubIdCodes", label: "Code PubID(1)", helperText: "ex : FR_AGEN_ANNO_PROD_0012_030_F" },
]

export const SpotSection = ({ form }: { form: UseFormMethods<FormulaireSchemaType> }) => {
    const { control, formState } = form
    return (
        <Paper elevation={2} style={{ padding: 18, marginBottom: 26, marginTop: 26 }}>
            <Typography variant="h5" component="h2" gutterBottom>
                Informations du spot
            </Typography>

            <Grid container spacing={3}>
                {spotFields.map((field) => (
                    <Grid item xs={12} sm={6} key={field.name}>
                        <FormTextField
                            label={field.label}
                            name={field.name}
                            control={control}
                            disabled={field.readOnly}
                            required={field.required}
                            formState={formState}
                            helperText={field.helperText}
                            type={field.type}
                        />
                    </Grid>
                ))}

                <Grid item xs={12} sm={6}>
                    <Box display="flex" alignItems="center">
                        <Controller
                            control={control}
                            name="spot.spotLink"
                            render={(field) => {
                                const { value } = field
                                return (
                                    <Link href={value} target="_blank" style={{ display: 'flex', alignItems: 'center' }}>
                                        Voir le spot <LaunchRoundedIcon color="primary" style={{ marginLeft: 4 }} />
                                    </Link>
                                )
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
            <SectionHelperText text="1) Le dépôt à la Sacem d’un spot publicitaire doit impérativement comprendre toutes les mentions relatives à l’identification des oeuvres musicales utilisées dans le spot." />
        </Paper>
    )
}